import { Component, OnInit,ChangeDetectorRef } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/generic/header/header.component';
import { FooterComponent } from './components/generic/footer/footer.component';
import { map, filter, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { UserState } from './store/user/user.model';
import { AppLauncherInfo } from './store/appLauncher/appLauncher.model';
import { SidebarComponent } from './components/views/admin/sidebar/sidebar.component';
import { ChangeDetectionStrategy } from "@angular/core";
import { UserProfileComponent } from './components/generic/user-profile/user-profile.component';
import { SwitchProfileComponent } from './components/generic/switch-profile/switch-profile.component';
import { loginSuccess, toggleTechView } from './store/user/user.actions';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterModule, CommonModule, FooterComponent, HeaderComponent,
  SidebarComponent, UserProfileComponent, SwitchProfileComponent,MatDialogModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  isAdmin$: Observable<boolean>;
  isAuthenticated$: Observable<boolean>;
  isAdminAndTech$: Observable<boolean>;
  isTechView$: Observable<boolean>;
  isPunchOut$: Observable<boolean>;
  showAdminItens$!: Observable<boolean>;
  isDashboardRoute: boolean = false;
  isResourceRoute: boolean = false;
  isAdminRoute: boolean = false;
  isStatisticsRoute: boolean = false;
  
  constructor(private router: Router, private store: Store<{ user: UserState }>, private store2: Store<{appLauncher: AppLauncherInfo}>,private cdr: ChangeDetectorRef,) {
    this.isAdmin$ = this.store.select('user').pipe(
      map(userState => userState.userInfo?.groups?.includes('AdminUsers') ?? false)
    );
    this.isAuthenticated$ = this.store.select('user').pipe(
      map(userState => !!userState.userInfo?.accessToken)
    );
    this.isAdminAndTech$ = this.store.select('user').pipe(
      map(userState => {
        const groups = userState.userInfo?.groups ?? [];
        return groups.includes('AdminUsers') && groups.some(group => group.includes('UnitedRentalsSAMLProvider'));
      })
    );
    this.isTechView$ = this.store.select('user').pipe(
      map(userState => userState.isTechView)
    );

    this.isPunchOut$ = this.store2.select('appLauncher').pipe(
      map(appLauncherInfo => appLauncherInfo.isPunchOut)
    );
  }

  ngOnInit() {
    this.isPunchOut$.subscribe(value => {
      //console.log('This is the value of isPunchOut  ' + value);
      this.cdr.markForCheck();
      this.cdr.detectChanges();
    });

    this.showAdminItens$ = this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event: NavigationEnd) => {
        const isProtectedRoute = event.url.startsWith('/admin') || event.url.startsWith('/technician');
        this.isDashboardRoute = event.url === '/admin/dashboard';
        this.isResourceRoute = event.url === '/admin/resource-database';
        this.isStatisticsRoute = event.url === '/admin/statistics';
        this.isAdminRoute = event.url.startsWith('/admin');
        return isProtectedRoute;
      })
    );
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      const userToken = localStorage.getItem('userToken');
      if (userToken) {
        const userInfo = JSON.parse(userToken);
        this.store.dispatch(loginSuccess({ userInfo }));
      }
      const savedTechView = localStorage.getItem('isTechView');
      if (savedTechView !== null && userToken) {
        const isTechView = JSON.parse(savedTechView);
        const userInfo = JSON.parse(userToken);
        this.store.dispatch(loginSuccess({ userInfo: { ...userInfo, isTechView } }));
      }
    }
  }
}